import adherentApi from '@/api/adherent.api'
import tiersApi from '@/api/tiers.api'

const module = {
  namespaced: true,

  state: {
    /**
     * {
        codeRegion:"26"
        coordonnee: {
        adresse:"LA METAIRIE"
        codePostal:"50150"
        complementAdresse:""
        email:"earlmetairie@agrialtest.com"
        telephoneFixe:"0233596754"
        telephonePortable:"0630111536"
        ville:"VENGEONS"
      }
    full:true
    numtiers:"733162"
    raisonSociale:"METAIRIE ( EARL LA)"
    responsable: {
      id:1
      nom:"TOULLIER"
      }
    }
     */
    adherent: {
      coordonnee: {},
      responsable: {}
    },
    tousConseillers: [],
    abonnements: {},
  },

  getters: {
    numtiers (state) {
      return state.adherent.numtiers
    },
    adherent (state) {
      return state.adherent
    },
    tousConseillers (state) {
      return state.tousConseillers
    },
    abonnements (state) {
      return state.abonnements
    }
  },
  mutations: {
    SET_ADHERENT (state, adherent) {
      state.adherent = adherent
    },
    SET_TOUS_CONSEILLERS (state, tousConseillers) {
      state.tousConseillers = tousConseillers
    },
    RESET (state) {
      state.adherent = {
        coordonnee: {},
        responsable: {}
      }
      state.abonnements = {}
    },

    RESET_NUMTIERS (state) {
      state.adherent.numtiers = null
      state.adherent = {}
      state.recolte = null
    },

    UPDATE_ABONNEMENTS (state, abonnements) {
      state.abonnements = abonnements
    },
  },
  actions: {
    selectAdherent ({ commit }, adherent) {
      commit('SET_ADHERENT', adherent)
    },
    resetNumtiers ({ commit }) {
      commit('RESET_NUMTIERS')
    },
    reset ({ commit }) {
      commit('RESET')
    },
    fetchAdherent ({ commit, rootGetters }, numtiers) {
      let numtiersSearch = numtiers || rootGetters['adherent/numtiers']
      return tiersApi.getTiers(numtiersSearch).then(tiers => {
        tiers.full = true
        commit('SET_ADHERENT', tiers)
        return tiers
      })
    },
    getTousConseillers ({ commit, rootGetters }) {
      const numtiers = rootGetters['adherent/numtiers']
      return adherentApi.getTousConseillers(numtiers).then(result => {
        commit('SET_TOUS_CONSEILLERS', result)
        return result
      })
    },
    fetchAbonnements ({ commit, rootGetters }, numtiers) {
      let numtiersSearch = numtiers || rootGetters['adherent/numtiers']
      if (numtiersSearch) {
        return adherentApi.getInfosCereales(numtiersSearch)
          .then(abonnements => commit('UPDATE_ABONNEMENTS', abonnements))
      } else {
        commit('UPDATE_ABONNEMENTS', {})
      }
    },
  }
}

export default module
